import { Box, useMediaQuery } from "@mui/material";
import { MOBLIE_VIEW_WIDTH } from "../../shared/constants/constants";
import ImageNotFound from "../../shared/assets/image/404.jpg";
import { useEffect } from "react";

function PageNotFound() {
  const matches = useMediaQuery(MOBLIE_VIEW_WIDTH);

  useEffect(() => {
    document.title = "Page Not Found";
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: "white",
        height: "61vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      id="malay"
    >
      <Box
        component="img"
        sx={{
          width: matches ? "66%" : "100%",
          height: matches ? "61vh" : "50vh",
          objectFit: "cover",
          objectPosition: "bottom",
        }}
        src={ImageNotFound}
      ></Box>
    </Box>
  );
}

export default PageNotFound;
